// The build-undo stack (IMPLEMENTATION §0.2 R13): `transient.undo`, newest last, at most
// `economy.buildUndoDepth` entries (the oldest drops off), cleared on load (transient). Machine merges
// (bmerge, shop buy+merge) and ghost cancels are not undoable; they purge every entry that references the
// buildings they changed, so an older entry can never act on a building that no longer matches it.
import type { Int } from './core/types.ts';
import type { Ctx } from './ctx.ts';
import type { Building, BuildOp, BuildSnap } from './state.ts';

export function snapOf(b: Building): BuildSnap {
  return {
    id: b.id,
    type: b.type,
    ore: b.type === 'deposit' ? b.ore : null,
    level: b.level,
    x: b.x,
    y: b.y,
    dir: b.dir,
    inDir: b.type === 'chute' ? b.inDir : null,
    paid: b.paid,
  };
}

export function pushUndo(c: Ctx, op: BuildOp): void {
  const st = c.s.transient.undo;
  st.push(op);
  while (st.length > c.d.economy.buildUndoDepth) st.shift();
}

function mentions(op: BuildOp, ids: readonly Int[]): boolean {
  for (const id of ids) {
    if (op.bids.includes(id)) return true;
    for (const s of op.snaps) if (s.id === id) return true;
  }
  return false;
}

/** Drops every entry that references one of `ids`. */
export function purgeUndo(c: Ctx, ids: readonly Int[]): void {
  const st = c.s.transient.undo;
  for (let i = st.length - 1; i >= 0; i--) if (mentions(st[i] as BuildOp, ids)) st.splice(i, 1);
}
